module.exports = __webpack_public_path__ + "static/media/adesivo_pepsi.1783d464.png";